export default __webpack_public_path__ + "static/media/ic-marker-uncollected.e57cb145.svg";